enum PromocodeRoutes {
  List = '/promocodes',
  Edit = '/promocodes/edit/:id',
  Add = '/promocodes/add',
}

export default PromocodeRoutes
